import { useEffect, useState } from 'react'

// Reactively tracks whether the viewport is at/below a mobile breakpoint. Used to move controls
// (e.g. filters/actions) into collapsed dropdowns on small screens without duplicating DOM.
export default function useIsMobile(query = '(max-width: 768px)'): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    const mq = window.matchMedia(query)
    const sync = () => setIsMobile(mq.matches)
    sync()
    mq.addEventListener('change', sync)
    return () => mq.removeEventListener('change', sync)
  }, [query])

  return isMobile
}
